module.exports = __webpack_public_path__ + "static/img/xunjian1.af8e5d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/xunjian1.png
// module id = BSVi
// module chunks = 2